(function($) {

      var lastFq = null;
      var lastFdt = 0;
      var lastTdt = 0;  
      var tagsCloud = {};

  AjaxSolr.TagcloudWidget = AjaxSolr.AbstractWidget.extend(
  /** @lends AjaxSolr.AbstractWidget.prototype */
  {
    /**
    * @param {Object} attributes
    * @param {String} attributes.field The field to facet on.
    * @param {Number} [attributes.start] This widget will by default set the
    *   offset parameter to 0 on each request.
    */
    constructor: function (attributes) {
      AjaxSolr.TagcloudWidget.__super__.constructor.apply(this, arguments);
      AjaxSolr.extend(this, {
        start: 0,
        field: null
      }, attributes);
    },

    init: function () {
      this.manager.store['facet'] = true;
	   // this.dateFilters();
    },
   
    /**
     * @param {String} value The value. If empty, removes the existing filter.
     * @returns {Function} Sets filter query with given value and sends a request to Solr.
     */
    setFilter: function (value) {

      return function () {
		var parentCod = $(this).parents('.popupContent').prop('className').split(' ')[1];
		var self;
		managerArray.forEach(function(element, index, array) {
			if (element.id == parentCod) {
				self = array[index].manager;
				return true;
			}
		})
        if(value.length) {
          self.store['fq'] = self.widgets["type"].field + ':' + self.escapeValue(value);
          self.fq = value;
          self["timeFilter"] = false;          
          self.store['start'] = 0;
        } else {
          delete self.store['fq'];
          self.fq = null;
          self.store['start'] = 0;
        }
        self.doRequest(null,parentCod);
        return false;
      }
    },

    appendItem: function(label, filter, count, isCurrent) {
      // Selected: <div>label (count)</div>
      // Not selected: <div><span class="tagcloud_item">label</span> (count)</div>

      //var $el2 = $('<div onclick="' + setFilter(filter) + '" />').text(' (' + count + ')');
      var $el2 = $('<div />').text('(' + count + ')');
      var $el = $('<span/>').text(label);

      if (!isCurrent) {
   	    $el2.addClass("tagcloud_item").click(this.setFilter(filter));
   		//$el2.addClass("tagcloud_item");

   	//	tagsCloud[tagsCloud.length] = {
   	//		$el2 : this.setFilter(filter)
   	//	}
      } else {
        $el2.addClass("tagcloud_item_current");
      }

      $el2.prepend($el);
      $(this.target).append($el2);
    },
    
    render: function(uniqueCod) {
		var _this;
		var _manager;
		managerArray.forEach(function(element, index, array) {
			if (element.id == uniqueCod) {
				_this = array[index].manager.widgets["type"];
				_manager = array[index].manager;
				return true;
			}
		})
		if(!_this){
			_this = this;
			_manager = _this.manager;
		}
      $(_this.target).empty();
      
	  //this.dateFilters{};
      // Special 'All' label
      _this.appendItem(get_message_string(391), '', _this.numFoundCache, (_manager.fq == null));
      
      // All the other labels
	  if(!_this.facetCache)
		  return;
      for (var i = 0, l = _this.facetCache.length; i < l; i++) {
        var facet = _this.facetCache[i].facet;
        _this.appendItem(getBPMName(facet), facet, _this.facetCache[i].count, (_manager.fq == facet));
        // debugger;

		// for(key in tt){
		// $(key).click(tt[key])

		// }

      }
    },
      
    afterRequest: function(uniqueCod) {
		var _this;
		var _manager;
		managerArray.forEach(function(element, index, array) {
			if (element.id == uniqueCod) {
				_this = array[index].manager.widgets["type"];
				_manager = array[index].manager;
				return true;
			}
		})
		if(!_this){
			_this = this;
			_manager = this.manager;
		}
		if (_this.manager.response.facet_counts.facet_fields[_this.field] === undefined) {
			$(_this.target).html('no items found in current selection');
			return;
		}

	  
		 if(!_this.manager.hasFilter() || _this.manager.store.fromDate != lastFdt || _this.manager.store.toDate != lastTdt){
			var objectedItems = [];
			var thisField;
			if(_manager["timeFilter"] == false){
				thisField = _manager.response.facet_counts.facet_fields[_this.field];
			}
			else
			{
				thisField = _manager.widgets.result.manager.response.facet_counts.facet_fields[_this.field];
			}
			for (var facet in thisField) {
			  var count = parseInt(thisField[facet]);
			  objectedItems.push({facet: facet, count: count});
			}
			objectedItems.sort(function(a, b) {
			  return a.facet < b.facet ? -1 : 1;
			});
			_this.facetCache = objectedItems;
			if(_manager["timeFilter"] == false){
				_this.numFoundCache = _manager.response.response.numFound;
			}
			else
			{
				_this.numFoundCache = _manager.widgets.result.manager.response.response.numFound;
			}
		  }
		 lastFq = _manager.fq;
		 lastFdt = _this.manager.store.fromDate;
		 lastTdt = _this.manager.store.toDate;
		  
		 this.render(uniqueCod);
    }

  });
  

  
})(jQuery);
